import { render, staticRenderFns } from "./CMarkedList.vue?vue&type=template&id=30fe132d&scoped=true&"
import script from "./CMarkedList.vue?vue&type=script&lang=js&"
export * from "./CMarkedList.vue?vue&type=script&lang=js&"
import style0 from "./CMarkedList.vue?vue&type=style&index=0&id=30fe132d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fe132d",
  null
  
)

export default component.exports